export enum PlatformType {
  Mac = 'mac',
  Windows = 'windows',
}
